export default {

  subscription (state) {
    if (state.isEnterpriseSubscriber) return 'ENTERPRISE'
    if (state.isProSubscriber) return 'PRO'
    if (state.isSubscriber) return 'STANDARD'
    else return null
  }

}
